import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { ModalBody as f } from "../components/ModalBody.js";
import { ModalFooter as h } from "../components/ModalFooter.js";
import { ModalHeader as s } from "../components/ModalHeader.js";
import { ModalShell as M } from "../components/ModalShell.js";
import { Button as m } from "../../Button/Button.js";
import { Tooltip as x } from "../../Tooltip/Tooltip.js";
const w = ({
  children: n,
  confirmText: t,
  closeText: c = "Close",
  loading: l = !1,
  title: o,
  tooltipTitle: a,
  onClose: i,
  onConfirm: p,
  ...d
}) => /* @__PURE__ */ e(M, { title: o, onClose: i, ...d, children: [
  /* @__PURE__ */ r(s, { children: o }),
  /* @__PURE__ */ r(f, { children: n }),
  /* @__PURE__ */ e(h, { children: [
    /* @__PURE__ */ r(m, { appearance: "accent", variant: "tertiary", onClick: i, children: c }),
    /* @__PURE__ */ r(x, { tooltip: a, show: !!a, children: /* @__PURE__ */ r(m, { appearance: "accent", variant: "primary", loading: l, onClick: p, children: t }) })
  ] })
] });
export {
  w as ConfirmModal
};
//# sourceMappingURL=ConfirmModal.js.map
